module.exports = __webpack_public_path__ + "img/sedan.fc99e9ee.svg";